import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom";

import moment from 'moment';

import Avatar from "../avatar";

import AppointmentsService from "../../services/appointmentsService";

import { getDate } from "../../utils";
import PatientsService from '../../services/patientsService';
import { GlobalContext } from '../../GlobalContext';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { t } from 'i18next';


const AppointmentsPage: React.FC = () => {

    let navigate = useNavigate();

    const [patient, setPatient] = useState(null);

    const [appointments, setAppointments] = useState<any[]>([]);

    const {setIsLoading} = useContext(GlobalContext);

    useEffect(() => {
        onAuthStateChanged(getAuth(), function (user) {
            if (user) {

                console.log(`patient: ${user.uid}`);

                setIsLoading(true)
                // Get patient data
                PatientsService.getPatient(user.uid)
                    .then((result) => {
                        setPatient(result);

                        // get appointments for patient
                        if (result) {
                            AppointmentsService.getAppointments(user.uid)
                                .then((appointmentsResults) => {

                                    // sort by date
                                    appointmentsResults.sort((a, b) => getDate(b.start) - getDate(a.start));

                                    const confirmedList = appointmentsResults.filter( a => a.status === undefined || a.status === "confirmed");

                                    setAppointments(confirmedList);

                                    setIsLoading(false);
                                })
                                .catch(() => { setIsLoading(false); });
                        } else {
                            setIsLoading(false);
                        }

                    })
                    .catch(() => { setIsLoading(false); });



            } else {
                // User is signed out.
                setPatient(null);
                setAppointments([]);
            }
        });

    }, []);



    function getAppointmentString(appointment) {
        if (appointment) {
            const startDate = moment(getDate(appointment.start));

            return `${startDate.format("dddd - DD.MM.YYYY - HH:mm")}`;
        }

        return "";
    }

    async function onDeleteButtonClick(appointment, doctor) {
        const startDate = moment(getDate(appointment.start));

        const doctorString = appointment.doctorFullName;
        const locationId = appointment.locationId;

        const dateString = `${startDate.format("dddd - DD.MM.YYYY - HH:mm")}`;
        let reallyDelete = window.confirm(t("pages.appointmentsPage.reallyCancelAppointment", { startDate:  dateString }));

        if (reallyDelete) {

            // remove from array to have an instant ui update
            setAppointments(appointments.filter(a => a.id !== appointment.id));

            await AppointmentsService.setLocationAppointmentStatus(appointment, patient, "declined");

            // now ask if patient wants to make a new appointment at that doctor
            let makeNewAppointment = window.confirm(t("pages.appointmentsPage.doYouWantToMakeAnAppointment", { doctor:  doctorString }));

            if (makeNewAppointment) {
                navigate(`/profile/${doctor.clientId}/${locationId}/${doctor.id}`);
            }

        }

    }


    function renderAppointment(appointment, canBeDeleted? : boolean) {

        const doctor = {
            id: appointment.doctorId,
            clientId: appointment.clientId,
            allowOnlineAppointments: true // ToDo: set this property
        };

        return doctor && (
            <div key={appointment.id} className="kt-user-appointment">
                <div>
                    <Link to={`/profile/${doctor.clientId}/${appointment.locationId}/${doctor.id}`}>
                        <Avatar doctor={doctor} alt="" width="40px" />
                    </Link>
                </div>
                <div>
                    <div>{appointment.doctorFullName.replace("Herr ", "").replace("Frau ", "")}</div>
                    <Link to={`/appointment/${doctor.clientId}/${appointment.locationId}/${appointment.id}`}>
                        <div className="kt-appointment-label"><strong>{getAppointmentString(appointment)}</strong></div>
                    </Link>
                    <div>{appointment.nameForPatient ? appointment.nameForPatient : appointment.visitMotiveName}</div>
                </div>
                <div className="kt-user-appointment-buttons">
                    <div>{t("pages.appointmentsPage.appointment").toUpperCase()}</div>
                    {doctor.allowOnlineAppointments && <div className="kt-btn" onClick={() => navigate(`/profile/${doctor.clientId}/${appointment.locationId}/${doctor.id}`)}><i className="fal fa-plus"></i> {t("components.buttons.create").toUpperCase()}</div>}
                    {canBeDeleted && <div className="kt-btn" onClick={() => onDeleteButtonClick(appointment, doctor)}><i className="fal fa-trash-alt"></i> {t("components.buttons.cancelAppointment").toUpperCase()}</div>}
                </div>

            </div>
        )

    }

    function renderAppointments(_appointments) {
        const today = new Date();
        const pastAppointments = _appointments.filter(a => getDate(a.start) < today);
        const futureAppointments = _appointments.filter(a => getDate(a.start) >= today);

        // sort by date
        pastAppointments.sort((a, b) => getDate(b.start) - getDate(a.start));
        futureAppointments.sort((a, b) => getDate(a.start) - getDate(b.start));

        return (
            <div className="kt-user-appointments">

                {futureAppointments.length > 0 &&
                    <div>
                        <h2>{t("pages.appointmentsPage.yourCommingAppointments")}</h2>
                        {futureAppointments.map((appointment) => renderAppointment(appointment, true))}
                    </div>
                }

                {pastAppointments.length > 0 &&
                    <div>
                        <h2>{t("pages.appointmentsPage.yourPastAppointments")}</h2>
                        {pastAppointments.map((appointment) => renderAppointment(appointment))}
                    </div>
                }

                {(futureAppointments.length === 0 && pastAppointments.length === 0) &&
                    <div>
                        <h2>{t("pages.appointmentsPage.yourAppointments")}</h2>
                        <div>{t("pages.appointmentsPage.noAppointments")}</div>
                    </div>
                }


            </div>
        );
    }

    return (
        <div className="kt-appointmentsPage">

            <div className="kt-body">

                {patient ?
                    <div className="kt-panel">
                        <div className="kt-panel-content">
                            {renderAppointments(appointments)}
                        </div>
                    </div>
                    :
                    <div className="kt-panel">
                        <div className="kt-panel-content">
                            <h2>{t("pages.appointmentsPage.pleaseLoginFirst")}</h2>
                            <p><Link to={"/login"}>{t("pages.appointmentsPage.linkToLogin")}</Link></p>

                            <p><Link to={"/register"}>{t("pages.appointmentsPage.orCreateANewAccount")}</Link></p>
                        </div>
                    </div>
                }


            </div>



        </div>
    );
}

export default AppointmentsPage;